import * as React from 'react';

function SvgAdd(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
      <defs>
        <style>{'.add_svg__cls-2{fill:#fff}'}</style>
      </defs>
      <g id="add_svg__add_player" transform="translate(-348 -272)">
        <g
          id="add_svg__Ellipse_14"
          data-name="Ellipse 14"
          transform="translate(348 272)"
          fill={props.fill}
          stroke="#11bc1f"
        >
          <circle cx={8} cy={8} r={8} stroke="none" />
          <circle cx={8} cy={8} r={7.5} fill="none" />
        </g>
        <path
          id="add_svg__Rectangle_222"
          d="M0 0h9.723v1.08H0z"
          className="add_svg__cls-2"
          data-name="Rectangle 222"
          transform="translate(351 279.321)"
        />
        <path
          id="add_svg__Rectangle_223"
          d="M0 0h9.723v1.08H0z"
          className="add_svg__cls-2"
          data-name="Rectangle 223"
          transform="rotate(90 40.701 315.701)"
        />
      </g>
    </svg>
  );
}

export default SvgAdd;
